"use client";

import Image from "next/image";
import React from "react";
const StatsCard1 = ({
  cardStyle,
  title,
  subtitle,
  icon,
  iconStyle,
  gridStyle
}: {
  cardStyle?: any;
  title: string;
  subtitle: string;
  icon: string | React.ReactNode;
  iconStyle?: any;
  gridStyle: {
    gridRow: string;
    gridColumn: string;
  };
}) => {
  return <div className="stats-section-card--1" style={{
    ...gridStyle,
    ...cardStyle
  }} data-sentry-component="StatsCard1" data-sentry-source-file="StatsCard1.tsx">
      <div className="stats-section-card--1--text">
        <div className="stats-section-card--title">{title}</div>
        <div className="stats-section-card--subtitle">{subtitle}</div>
      </div>
      {typeof icon === "string" ? <Image src={icon} alt="icon" width={113} height={97} style={iconStyle} /> : icon}
    </div>;
};
export default StatsCard1;